import { createPortal } from "react-dom";
import { useState, useEffect } from "react";
const Portal = _ref => {
  var _navigator$userAgent;
  let {
    children
  } = _ref;
  const [isInBrowser, setIsInBrowser] = useState(false);
  useEffect(() => {
    setIsInBrowser(true);
  }, []);

  /*
  Eden's current testing approach is to use a test helper context that adds the 
  component to a `<div>` within the `<body>`. Since the portal is appending to
  the body and not within the test context, the tests fail without the "jsdom"
  condition.
  */
  if (isInBrowser && !((_navigator$userAgent = navigator.userAgent) !== null && _navigator$userAgent !== void 0 && _navigator$userAgent.includes("jsdom"))) {
    let body = document.body;
    return /*#__PURE__*/createPortal(children, body);
  }
  return children;
};
export default Portal;